import React from 'react';
import SFooterDrawer from './SFooterDrawer';
import { SButton } from '../atoms/SButton';
import { useUserLocation } from '@/hooks/useUserLocation';
import './ShopDrawer.css';

export interface ShopDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue?: () => void;
}

const ShopDrawer: React.FC<ShopDrawerProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => {
  const { location: userLocation } = useUserLocation();

  const getLocationName = () => {
    if (userLocation?.name) return userLocation.name;
    return 'your location';
  };

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
    onClose();
  };

  return (
    <SFooterDrawer
      isOpen={isOpen}
      onClose={onClose}
      title=""
      height="auto"
      className="shop-drawer"
    >
      <div className="shop-drawer-content">
        <div className="shop-message">
          <p className="shop-message-text">
            Your default location is <strong>{getLocationName()}</strong>. You can change it in the Shop page to your booking location.
          </p>
        </div>
        
        <div className="shop-drawer-actions">
          <SButton
            variant="primary"
            size="lg"
            label="Continue"
            onClick={handleContinue}
            className="shop-continue-btn"
          />
        </div>
      </div>
    </SFooterDrawer>
  );
};

export default ShopDrawer;
